/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { bulkScenarioDependencyRestRequestSchema } from './bulkScenarioDependencyRestRequestSchema';

export const bulkScenarioDependencyStageRequestSchema = z.object({
  get request() {
    return bulkScenarioDependencyRestRequestSchema;
  },
  sessionId: z.string().min(1),
});
